<template>
  <div class="container">
    <div>
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('PrimaryAgentID')">
          <el-input v-model="queryForm.UserId" :placeholder="$t('EnterTopLevelAgentID')" style="width: 150px" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('Currency2')">
          <el-select v-model="queryForm.Symbol" :placeholder="$t('SelectCurrency2')" style="width: 150px" clearable>
            <el-option :label="$t('all')" value=""> </el-option>
            <el-option label="USDT" value="usdt"> </el-option>
            <el-option label="TRX" value="trx"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="佣金结算时间段">
          <el-date-picker style="width: 300px" v-model="queryForm.date" type="daterange" :range-separator="$t('To')" :start-placeholder="$t('startTime')"  :end-placeholder="$t('endTime')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" @click="getDataList">{{$t('Search')}}</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="exportData">{{$t('Export')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table :data="tableData" border :cell-style="{ padding: '1' }" show-summary :summary-method="getSummaries">
        <el-table-column width="100" align="center" prop="name" label="结算时间段" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="{active:scope.row.name !='小计'}" @click="toShowDetail(scope.row)">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="count" label="代理线" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" :label="$t('Odds')" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" :label="$t('CommissionRebateRatio')" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="投注金额(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="公司盈亏(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="公返佣金额(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="已领取金额(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" :label="$t('ForfeitedAmountUT')" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" :label="$t('EventFund')+'(U/T)'" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="实际盈亏(U/T)" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <!-- 详情 -->
    <el-dialog title="每日佣金数据" :visible.sync="showDetail" width="1000px" center>
      <div style="display:flex;margin-bottom:10px;">
        <span style="margin-right:20px;">代理线：98-1988 </span>
        <span style="margin-right:20px;">赔率：1.98</span>
        <span>返佣比例：2%</span>
      </div>
      <el-table :data="dtailTableData" border :cell-style="{ padding: '1' }">
        <el-table-column align="center" prop="count" :label="$t('Date')" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="投注金额(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="公司盈亏(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="返佣金额(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="已领取金额(U/T)" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" :label="$t('ForfeitedAmountUT')" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" :label="$t('EventFund')+'(U/T)'" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="count" label="实际盈亏(U/T)" show-overflow-tooltip></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CommissionDetails",
  data() {
    return {
      queryForm: {
        UserId: "",
        Symbol: "",
        date: [
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate()
          ),
        ],
      },
      tableData: [
        { name: "2023-10-12", count: 111 },
        { name: "2023-10-12", count: 222 },
      ],
      Summarie: {},
      showDetail: false,
      dtailTableData: [],
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    toShowDetail(row) {
      if (row.name == "小计") return;
      this.showDetail = true;
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('Summary');
        } else if (column.property == "count") {
          sums[index] = "111";
        }
      });
      return sums;
    },
    getDataList() {
      this.Summarie = {};
      this.tableData = [
        { name: "2023-10-12", count: 111 },
        { name: "2023-10-12", count: 222 },
      ];
      this.tableData.push({ name: "小计", count: 222 });
      //   this.Summarie.BetAmountYue += app.getNumDecimal(item.BetAmountYue);
    },
    exportData() {},
  },
};
</script>

<style  scoped>
.active {
  color: #409eff;
  cursor: pointer;
}
</style>